import { Routes } from '@angular/router';
import { AuthGuard } from '@app/_guards';
import { NonInfluencerGuard } from '@app/_guards/non-influencer.guard';
import { ProjectAddComponent } from './project-add';
import { ProjectListComponent } from './project-list';
import { AddInfluencerComponent } from './add-influencer';
import { InfluencerAddComponent } from '@app/modules/influencer/influencer-add';
import { ShareProjectComponent } from './share-project';
import { WidgetInstructionsComponent } from '@app/modules/project/widget-instrcutions/widget-instructions.component';
import { ThirdpartyPlatformsComponent } from './thirdparty-platforms-view';
import { InfluencerAutoJoinComponent } from './influencer-auto-join-view';
import { PROJECT_MONITORING_ROUTE } from './monitoring/monitoring.route';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {INFLUENCER_ROUTES} from '../influencer/influencer.routes';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: ProjectListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'projects/create',
        component: ProjectAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard]
      },
      {
        path: 'projects/:projectId/influencer-auto-join',
        component: InfluencerAutoJoinComponent,
        canActivate: [AuthGuard, NonInfluencerGuard]
      },
      {
        path: 'projects/:projectId/edit',
        component: ProjectAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard],
        data: {navTitle: 'Project settings'}
      },
      {
        // The old inline edit page (ProjectViewComponent) has been merged into
        // ProjectAddComponent; keep deep links to /projects/:id working.
        path: 'projects/:id',
        redirectTo: 'projects/:id/edit'
      },
      {
        path: 'project/:id/add-influencer',
        component: AddInfluencerComponent,
        canActivate: [AuthGuard, NonInfluencerGuard],
        data: {navParent: 'project.influencers', navTitle: 'Add influencers'}
      },
      {
        path: 'project/:projectId/influencer/add',
        component: InfluencerAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard],
        data: {navParent: 'project.influencers', navTitle: 'New influencer'}
      },
      {
        path: 'project/:projectId/influencer/edit/:influencerId',
        component: InfluencerAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard],
        data: {navParent: 'project.influencers', navTitle: 'Edit influencer'}
      },
      {
        path: 'projects/:projectId/share',
        component: ShareProjectComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'projects/:projectId/widget',
        component: WidgetInstructionsComponent,
        canActivate: [AuthGuard, NonInfluencerGuard]
      },
      {
        path: 'projects/:projectId/registration-platforms',
        component: ThirdpartyPlatformsComponent,
        canActivate: [AuthGuard, NonInfluencerGuard]
      },
      PROJECT_MONITORING_ROUTE
    ]
  }
];

/** What the feature registers: its own routes, then those of the feature it brings in. */
export const PROJECT_ROUTES: Routes = [...routes, ...INFLUENCER_ROUTES];
